import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";

export interface PowerBiEmbededToken {
	token: string;
	tokenId: string; // Guid as string
	expiration: Date;
}

export interface PowerBiEmbededUrl {
	id: string; // Guid as string
	reportType: string;
	name: string;
	webUrl: string;
	embedUrl: string;
}

export interface PowerBiReportResponse {
	embededToken: PowerBiEmbededToken;
	embededUrls: PowerBiEmbededUrl[];
}

export class PowerBiReportResource
	extends BaseCamelCasedResource
	implements PowerBiReportResponse
{
	embededToken: PowerBiEmbededToken = {
		token: "",
		tokenId: "",
		expiration: new Date()
	};

	embededUrls: PowerBiEmbededUrl[] = [];

	pk() {
		return this.embededToken?.tokenId ?? "";
	}

	static urlRoot = apiResourceUrl("powerbi-report");
}
